export const de = {
    'buttons': {
        'return': 'Zurück'
    },
    'selects': {
        'currency': {
            'label': 'Währung',
            'placeholder': 'Wählen Sie eine Währung',
            'options-title': 'Liste der verfügbaren Währungen'
        },
        'currency-and-network': {
            'placeholder': 'Wählen Sie eine Währung und ein Netzwerk',
            'options-title': 'Liste der verfügbaren Währungen'
        },
        'selected-label': 'Ausgewählt: {selected} von {length}',
        'search': 'Suchen',
        'errors': {
            'invalid': 'Ungültiger Wert',
            'required': 'Erforderlich',
            'card-holder': 'Geben Sie den Vor- und Nachnamen des Karteninhabers ein',
            'input-amount': 'Betrag eingeben',
            'fill-card': 'Füllen Sie die Kartendaten aus'
        },
        'empty-list': 'Leere Liste',
        'address': {
            'label': 'Auszahlungsadresse in {currency}',
            'options-title': 'Liste der verfügbaren Adressen'
        },
        'cardholder-input': {
            'placeholder': 'Karteninhaber'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Ihre Adresse für die Einzahlung'
            },
            'invoice': {
                'address': 'Adresse',
                'paid-amount': 'Bezahlter Betrag'
            }
        }
    },
    'labels': {
        'deposit': 'Einzahlung',
        'withdraw': 'Auszahlung',
        'currency': 'Währung',
        'amount': 'Betrag',
        'invoice': {
            'remaining-time': 'Verbleibende Zeit für die Zahlung',
            'status': {
                'expires': 'Zeit abgelaufen',
                'success': 'Zahlung erfolgreich',
                'error': 'Fehler'
            },
            'partially-paid': {
                'title': 'Teilweise bezahlt',
                'info': 'Der Betrag wurde teilweise bezahlt. Der Restbetrag muss für eine erfolgreiche Zahlung beglichen werden.'
            },
            'orphan': {
                'title': 'Verwaiste Transaktion',
                'description': 'Eine der Transaktionen in dieser Bestellung enthält ein falsches Netzwerk oder eine falsche Währung.',
                'contact': 'Kontaktieren Sie den technischen Support mit der ID:'
            },
            'you-paid': 'Sie haben bezahlt',
            'active-order': 'Aktive Bestellung',
            'new-invoice': 'Neue Rechnung',
            'order-id': 'Rechnungs-ID',
            'payment-amount': 'Zahlungsbetrag'
        },
        'continue': 'Weiter',
        'payout': {
            'address': 'Auszahlungsadresse in {currency}',
            'tag-or-memo': 'TAG oder MEMO',
            'status': {
                'processed': 'Erfolgreich',
                'error': 'Fehler',
                'orphan': 'Verwaiste Transaktion',
                'approve_rejected': 'Abgelehnt',
                'in-progress': 'In Bearbeitung',
                'need-approve': 'Erfordert Genehmigung',
                'awaiting-confirmation': 'Ihre Auszahlungsanfrage wartet auf Bestätigung'
            },
            'info': {
                'withdraw-id': 'Auszahlungs-ID',
                'tx-hash': 'TX-Hash',
                'currency-and-network': 'Währung und Netzwerk',
                'address': 'Adresse',
                'tag-or-memo': 'TAG oder MEMO',
                'amount': 'Auszahlungsbetrag'
            }
        },
        'fiat': {
            'title': 'Einzahlung über Fiat',
            'info': {
                'amount': 'Betrag',
                'date': 'Zahlungsdatum',
                'id': 'Einzahlungs-ID',
                'system': 'Zahlungssystem'
            },
            'status': {
                'new': 'Neu',
                'pending': 'Ausstehend',
                'authorized': 'Autorisiert',
                'confirmed': 'Bestätigt',
                'reconciled': 'Abgestimmt',
                'error': 'Fehler',
                'declined': 'Abgelehnt'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'Falsche Widget-ID',
        'wrong-ext-user-id': 'Falsche externe Benutzer-ID',
        '404': 'Hoppla! Wir haben gesucht, aber nicht gefunden, was Sie suchen.',
        'without-xt-user-id-withdrawal': 'Auszahlung nicht verfügbar. Der Parameter extUserId wurde nicht übermittelt',
        'without-xt-user-id-deposit': 'Einzahlung nicht verfügbar. Der Parameter extUserId wurde nicht übermittelt'
    },
    'invoice': {
        'order': 'Bestellung',
        'inputs': {
            'email': {
                'label': 'E-Mail-Adresse',
                'placeholder': 'Geben Sie Ihre E-Mail-Adresse ein'
            },
            'amount': {
                'label': 'Betrag',
                'placeholder': 'Betrag eingeben'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Betrag in',
                'rate': 'Wechselkurs',
                'payment-id': 'Zahlungs-ID',
                'description': 'Beschreibung'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Seite nicht aktualisieren oder konto im neuen',
            'new-tab': 'neuen Tab'
        },
        'statuses': {
            'ERROR': 'FEHLER',
            'PENDING': 'AUSSTEHEND',
            'PROCESSED': 'VERARBEITET',
            'REJECTED': 'ABGELEHNT',
            'OVERPAID': 'ÜBERZAHLT',
            'CREATED': 'ERSTELLT',
            'PARTIAL': 'TEILWEISE BEZAHLT',
            'INIT': 'INITIIERT',
            'EXPIRED': 'ABGELAUFEN'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Einzahlung',
            'payment-history': 'Zahlungsverlauf'
        },
        'payment-history': {
            'empty-label': 'Alle Ihre an die angegebene Adresse gesendeten Transaktionen werden hier verfügbar sein',
            'headers': {
                'date': 'Datum und Uhrzeit',
                'amount': 'Betrag',
                'tx': 'Tx-Hash',
                'status': 'Status'
            },
            'statuses': {
                'processed': 'Verarbeitet',
                'pending': 'Ausstehend',
                'rejected': 'Abgelehnt',
                'error': 'Fehler'
            },
            'in': 'in'
        },
        'qr-block': {
            'empty-label': 'Aufladen mit Kryptowährung',
            'qr-info-pre-invoice': 'Senden Sie nur',
            'qr-info-pre-personal': 'Senden Sie einen beliebigen Betrag nur an',
            'qr-info-post': 'an diese Adresse',
            'qr-info-minimal': 'Überweisungen im Wert von weniger als 1 USD werden nicht gutgeschrieben'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Einzahlung über Fiat',
            'payment-history': 'Zahlungsverlauf'
        },
        'labels': {
            'pay': 'Bezahlen',
            'service-commission': 'Servicegebühr',
            'total': 'Gesamt',
            'you-pay': 'Sie zahlen'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Verwaiste Transaktion',
            'info': 'Eine der Transaktionen in dieser Bestellung enthält ein falsches Netzwerk oder eine falsche Währung.',
            'support': 'Kontaktieren Sie den technischen Support mit der ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Indem Sie auf die Schaltfläche „Weiter“ klicken, stimmen Sie automatisch',
        'our': 'unserer Cookie-Richtlinie zu'
    },
    'payout': {
        'payout': 'Auszahlung',
        'output': 'Ausgabe',
        'withdraw': 'Abheben',
        'errors': {
            'wrong-address': 'Die Adresse gehört nicht zum Netzwerk {network}'
        }
    }
}
